import photoEndBase from "./assets/base/end.png";
import photoEndOudenaarde from "./assets/oudenaarde/end.png";
import avatarBase from "./assets/base/avatar.svg";
import avatarOudenaarde from "./assets/oudenaarde/avatar.svg";
import logoMol from "./assets/images/mol-logo.png";
import logoGeraardsbergen from "./assets/images/geraardsbergen-logo.svg";
import logoOudenaarde from "./assets/images/oudenaarde-logo.svg";
import photoGemeenteMol from "./assets/images/foto-gemeente-mol.jpg";
import photoGemeenteGeraardsbergen from "./assets/images/foto-gemeente-geraardsbergen.jpg";
import photoGemeenteOudenaarde from "./assets/images/foto-gemeente-oudenaarde.jpg";

const MUNICIPALITY_CONFIG = {
  mol: {
    characterName: "Sofie",
    pageTitle: "Bevraging Mol",
    scriptFilename: "mol",
    avatarFile: avatarBase,
    footerAvatar: true,
    logoFile: logoMol,
    assets: {
      "foto-einde": photoEndBase,
      "foto-einde-2": photoEndBase,
      "foto-gemeente": photoGemeenteMol,
      "foto-gemeente-mol": photoGemeenteMol,
    },
  },
  geraardsbergen: {
    characterName: "Gerrie van Geraardsbergen",
    pageTitle: "Bevraging Geraardsbergen",
    scriptFilename: "geraardsbergen",
    avatarFile: avatarBase,
    footerAvatar: true,
    logoFile: logoGeraardsbergen,
    assets: {
      "foto-einde": photoEndBase,
      "foto-einde-2": photoEndBase,
      "foto-gemeente": photoGemeenteGeraardsbergen,
      "foto-gemeente-geraardsbergen": photoGemeenteGeraardsbergen,
    },
  },
  oudenaarde: {
    characterName: "Ollie van Oudenaarde",
    pageTitle: "Bevraging Oudenaarde",
    scriptFilename: "oudenaarde",
    avatarFile: avatarOudenaarde,
    footerAvatar: false,
    logoFile: logoOudenaarde,
    assets: {
      "foto-einde": photoEndOudenaarde,
      "foto-gemeente-oudenaarde": photoGemeenteOudenaarde,
    },
  },
};

export function getMunicipalityConfig(gemeente) {
  return MUNICIPALITY_CONFIG[gemeente];
}
